/* Rotating headline word.

   Cycles the words inside [data-word-rotate], animating each out and the
   next in, and transitions the wrapper's width so the box grows and shrinks
   with the word instead of snapping. Each word carries its own trailing
   period (see blocks/heading.liquid), so nothing trails the stack and the
   period cannot lag behind the word it belongs to.

   In stacked mode the wrapper is a block with auto side margins, so an
   animating width grows the word symmetrically about the line's center.

   The markup carries the words; this only drives the classes. Keeping the
   list in Liquid means it is editable in the theme editor and it is in the
   first HTML the browser receives, so the headline is never empty on paint.

   See blocks/heading.liquid for the aria handling: the stack is aria-hidden
   and the heading carries an aria-label, so a screen reader hears the
   sentence once rather than five words in a row. An earlier version used a
   visually-hidden span for that, which rendered at full size because the
   class does not exist in this theme. */
(function () {
  "use strict";

  var ANIM_MS = 450;   // must match tru-word-in / tru-word-out in the CSS
  var rotators = document.querySelectorAll("[data-word-rotate]");
  if (!rotators.length) return;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  rotators.forEach(function (wrap) {
    var words = Array.prototype.slice.call(wrap.querySelectorAll(".word-rotate__word"));
    if (words.length < 2) return;

    var i = 0;
    var timer = null;
    var seconds = parseFloat(wrap.getAttribute("data-interval"));
    /* The schema stores seconds; older markup stored milliseconds. Accept
       either rather than depending on which one wrote the attribute. */
    var interval = !seconds ? 2500 : (seconds < 60 ? seconds * 1000 : seconds);

    /* Width is measured from the word itself. Every word is in the DOM at
       full size -- the inactive ones are absolutely positioned, not hidden --
       so each already has a real box to measure. No clones, no reflow
       thrash, and the measurement is of the real rendered font rather than
       an estimate. */
    function widthOf(el) {
      return Math.ceil(el.getBoundingClientRect().width);
    }

    /* Stacked mode sizes itself: all words share one grid cell, so the
       column is permanently as wide as the longest word. Touching width here
       would reintroduce the diagonal drift the grid exists to remove. */
    var stacked = wrap.classList.contains("word-rotate--stack");

    function sizeToActive() {
      if (stacked) return;
      wrap.style.width = widthOf(words[i]) + "px";
    }

    /* Fonts change glyph widths. Univers Black is self-hosted with
       font-display: block, so a width measured before it lands would be the
       fallback's and the period would sit wrong until the next tick. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sizeToActive).catch(function () {});
    }
    sizeToActive();
    window.addEventListener("resize", sizeToActive, { passive: true });

    function step() {
      var current = words[i];
      var next = words[(i + 1) % words.length];

      current.classList.remove("is-active");
      current.classList.add("is-leaving");
      next.classList.add("is-active", "is-entering");

      i = (i + 1) % words.length;
      if (!stacked) wrap.style.width = widthOf(next) + "px";

      window.setTimeout(function () {
        current.classList.remove("is-leaving");
        next.classList.remove("is-entering");
      }, ANIM_MS + (reduce ? 0 : 60));
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(step, interval);
    }
    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    /* Nothing to animate in a background tab, and a timer that keeps firing
       there desynchronises from the animation on return. */
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else start();
    });

    start();
  });
})();
